import {
  useRef, useEffect, useState,
} from 'react';
import { nanoid } from 'nanoid';
import Hubs from '@/components/fields/hubs.js';
import { useSearchZustandStore } from '@/helpers/searchctx.js';
import Emitter from '@/helpers/emitter.js';
import { getPlaceData } from '@/helpers/position.js';
import { useTranslation } from '@/helpers/translate';

function EventListener() {
  function changeCategory(category) {
    // console.log('fnSearchFromSearchPage category', category);
    const { initParams } = useSearchZustandStore.getState();
    useSearchZustandStore.setState({
      category,
      initParams: { ...initParams, category },
      searchEvent: { action: 'searchPageSearchcallsearch' },
      clearAllMarkers: nanoid(),
      userUsingPlateform: nanoid(),
    });
    return true;
  }

  async function changeHub(hub) {
    if (typeof google !== 'undefined' && hub) {
      // console.log('fnSearchFromSearchPage hub', hub);
      let location = { ...hub?.location };
      if (hub.gg_place_id) {
        const resPlace = await getPlaceData({ place_id: hub.gg_place_id });
        if (!resPlace) return alert('Please contact OfficeRider client support');
        // console.log('resPlaceresPlace', resPlace);
        location = {
          ...resPlace.location,
        };
      }

      Emitter.emit('search_map_build_clearAllMarkers', true);
      Emitter.emit('search_map_build_moveMap', {
        ...location, zoom: 13, hub: hub.slug, title: hub.title,
      });
    }
    return true;
  }

  useEffect(() => {
    Emitter.on('headersearchpagechangecategory', changeCategory);
    Emitter.on('headersearchpagechangehub', changeHub);
    return () => {
      Emitter.off('headersearchpagechangecategory', changeCategory);
      Emitter.off('headersearchpagechangehub', changeHub);
    };
  }, []);

  return null;
}

function SearchPageComponent() {
  const { t } = useTranslation();
  const [hub, setHub] = useState({
    title: '',
    location: {
      lat: null,
      lng: null,
    },
  });
  const hubsRef = useRef();

  useEffect(() => {
    const initParams = useSearchZustandStore?.getState()?.initParams;
    console.log('initParams', initParams);
    setHub({
      title: initParams?.title || '',
      location: {
        lat: initParams?.lat,
        lng: initParams?.lng,
      },
    });
  }, []);

  return (
    <div className="z-40 my-3 text-lg max-w-[280px] lg:max-w-5/6 lg:static lg:ml-10">
      <div className="relative flex items-center w-full text-base transition-colors duration-300 border rounded-lg h-11 lg:text-lg lg:w-72 border-purple-4/30 lg:shadow-light hover:bg-purple/10">
        <svg className="absolute ml-4 size-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.4705 19.5313C18.7633 19.8242 19.2382 19.8242 19.5311 19.5313C19.824 19.2384 19.824 18.7635 19.5311 18.4706L18.4705 19.5313ZM14.3341 13.2736C14.0412 12.9807 13.5663 12.9807 13.2735 13.2736C12.9806 13.5665 12.9806 14.0414 13.2735 14.3343L14.3341 13.2736ZM19.5311 18.4706L14.3341 13.2736L13.2735 14.3343L18.4705 19.5313L19.5311 18.4706ZM14.3341 14.3343C16.4183 12.2501 17.2323 9.21223 16.4694 6.36512L15.0206 6.75335C15.6447 9.08282 14.9787 11.5683 13.2735 13.2736L14.3341 14.3343ZM16.4694 6.36512C15.7066 3.51802 13.4827 1.29417 10.6356 0.531292L10.2474 1.98018C12.5769 2.60436 14.3964 4.42388 15.0206 6.75335L16.4694 6.36512ZM10.6356 0.531292C7.7885 -0.231588 4.75068 0.582396 2.66645 2.66662L3.72711 3.72728C5.4324 2.02199 7.91791 1.356 10.2474 1.98018L10.6356 0.531292ZM2.66645 2.66662C-0.555484 5.88856 -0.555484 11.1123 2.66645 14.3343L3.72711 13.2736C1.09096 10.6375 1.09096 6.36343 3.72711 3.72728L2.66645 2.66662ZM2.66645 14.3343C5.88839 17.5562 11.1122 17.5562 14.3341 14.3343L13.2735 13.2736C10.6373 15.9098 6.36326 15.9098 3.72711 13.2736L2.66645 14.3343Z" fill="white" />
        </svg>
        <Hubs 
          key={`headersearchepagesearchbyinitparams${hub.title}`}
          ref={hubsRef} 
          fromSearchPage 
          defaultTitle={hub.title} 
          classesDefault={{ container: 'absolute text-base lg:text-lg w-full no-margin', input: 'w-full pl-12 pr-3 lg:w-72 truncate border-none py-2 text-black-light focus:border-0 hover:bg-purple-0 focus:bg-purple-0 focus:ring-0 text-sm [&.hub-open]:focus:bg-purple [&.hub-open]:focus:border-purple [&.hub-open]:focus:ring-1 [&.hub-open]:focus:ring-purple' }} />
      </div>
      <EventListener />
    </div>
  );
}

export default SearchPageComponent;
